import { useState, useEffect } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import {
  FaBars, FaTimes, FaBell, FaSignOutAlt,
  FaTachometerAlt, FaUniversity, FaMoneyBillWave,
  FaBus, FaCalendarAlt, FaBook, FaGraduationCap, FaPlusCircle, 
  FaFileAlt, FaWallet, FaReceipt, FaClipboardList, FaArrowUp,
  FaBuilding, FaUserTie, FaKey, FaChevronLeft, 
  FaChevronRight, FaShieldAlt, FaNewspaper, FaPiggyBank,
  FaChevronDown, FaChevronUp
} from 'react-icons/fa';
import { useAuth } from '../../../context/AuthContext';
import { useNotifications } from '../../../context/NotificationContext';
import './Navbar.css';

const MENUS = {
  superadmin: [
    { label: 'Dashboard',      path: '/superadmin',                icon: <FaTachometerAlt /> },
    { label: 'Fee Due List',   path: '/superadmin/defaulters',     icon: <FaClipboardList /> },
    { label: 'Total Due List', path: '/superadmin/total-due-list', icon: <FaWallet /> },
    { label: 'Daily Report',   path: '/superadmin/daily-report',   icon: <FaFileAlt /> },
    { label: 'Expense Book',   path: '/superadmin/expense-book',   icon: <FaBook /> },
    { label: 'Alert Log',      path: '/superadmin/alert-log',      icon: <FaShieldAlt /> },
    { label: 'View News',      path: '/superadmin/news/view',      icon: <FaNewspaper /> },
    { label: 'Notifications',  path: '/notifications',             icon: <FaBell /> },
  ],
  admin: [
    { label: 'Dashboard',        path: '/admin',                  icon: <FaTachometerAlt /> },
    { label: 'Sessions',         path: '/admin/sessions',         icon: <FaCalendarAlt /> },
    { label: 'View Colleges',    path: '/admin/colleges',         icon: <FaUniversity /> },
    { label: 'Banks',            path: '/admin/banks',            icon: <FaPiggyBank /> },
    {
      label: 'Employees', icon: <FaUserTie />,
      subMenus: [
        { label: 'Departments',      path: '/admin/departments',      icon: <FaBuilding /> },
        { label: 'Employees',        path: '/admin/employees',        icon: <FaUserTie /> },
        { label: 'Attendance',       path: '/admin/attendance',       icon: <FaCalendarAlt /> },
        { label: 'Salary',           path: '/admin/salary',           icon: <FaMoneyBillWave /> },
        { label: 'Advance Salary',   path: '/admin/salary/advance',   icon: <FaWallet /> },
      ]
    },
    {
      label: 'Students', icon: <FaGraduationCap />,
      subMenus: [
        { label: 'Classes',          path: '/admin/classes',          icon: <FaBook /> },
        { label: 'Add Student',      path: '/admin/students/add',     icon: <FaPlusCircle /> },
        { label: 'View Students',    path: '/admin/students/view',    icon: <FaGraduationCap /> },
        { label: 'Promote Students', path: '/admin/promote-students', icon: <FaArrowUp /> },
      ]
    },
    { label: 'Transport',        path: '/admin/transport',        icon: <FaBus /> },
    {
      label: 'Fee Management', icon: <FaReceipt />,
      subMenus: [
        { label: 'Fee Structure',    path: '/admin/fees',             icon: <FaReceipt /> },
        { label: 'Fee Collection',   path: '/admin/fee-collection',   icon: <FaMoneyBillWave /> },
        { label: 'Receipt Log',      path: '/admin/receipt-log',      icon: <FaReceipt /> },
        { label: 'Fee Due List',     path: '/admin/defaulters',       icon: <FaClipboardList /> },
        { label: 'Total Due List',   path: '/admin/total-due-list',   icon: <FaWallet /> },
        { label: 'Daily Report',     path: '/admin/daily-report',     icon: <FaFileAlt /> },
      ]
    },
    {
      label: 'Expense Management', icon: <FaBook />,
      subMenus: [
        { label: 'Expense Heads',    path: '/admin/expense-heads',    icon: <FaFileAlt /> },
        { label: 'Add Expense',      path: '/admin/add-expense',      icon: <FaPlusCircle /> },
        { label: 'Expense Book',     path: '/admin/expense-book',     icon: <FaBook /> },
      ]
    },
    {
      label: 'News', icon: <FaNewspaper />,
      subMenus: [
        { label: 'Add News',         path: '/admin/news/add',         icon: <FaNewspaper /> },
        { label: 'View News',        path: '/admin/news/view',        icon: <FaNewspaper /> },
      ]
    },
    { label: 'Notifications',    path: '/notifications',          icon: <FaBell /> },
    { label: 'Alert Log',        path: '/admin/alert-log',        icon: <FaShieldAlt /> },
    {
      label: 'Tally Export', icon: <FaUserTie />,
      subMenus: [
        { label: 'Receipt',      path: '/admin/tally-receipt',      icon: <FaReceipt /> },
        { label: 'Journal Salary',        path: '/admin/tally-journal-salary',        icon: <FaUserTie /> },
        { label: 'Journal Fees',        path: '/admin/tally-journal-fees',        icon: <FaUserTie /> },
        { label: 'Expense',       path: '/admin/tally-expense',       icon: <FaCalendarAlt /> },
        { label: 'Salary',       path: '/admin/tally-salary',       icon: <FaCalendarAlt /> },
      ]
    },

  ],


  collegeadmin: [
    { label: 'Dashboard',        path: '/collegeadmin',                  icon: <FaTachometerAlt /> },
    { label: 'Sessions',         path: '/collegeadmin/sessions',         icon: <FaCalendarAlt /> },
    { label: 'Banks',            path: '/collegeadmin/banks',            icon: <FaPiggyBank /> },
    {
      label: 'Employees', icon: <FaUserTie />,
      subMenus: [
        { label: 'Departments',      path: '/collegeadmin/departments',      icon: <FaBuilding /> },
        { label: 'Employees',        path: '/collegeadmin/employees',        icon: <FaUserTie /> },
        { label: 'Attendance',       path: '/collegeadmin/attendance',       icon: <FaCalendarAlt /> },
        { label: 'Salary',           path: '/collegeadmin/salary',           icon: <FaMoneyBillWave /> },
        { label: 'Advance Salary',   path: '/collegeadmin/salary/advance',   icon: <FaWallet /> },
      ]
    },
    {
      label: 'Students', icon: <FaGraduationCap />,
      subMenus: [
        { label: 'Classes',          path: '/collegeadmin/classes',          icon: <FaBook /> },
        { label: 'Add Student',      path: '/collegeadmin/students/add',     icon: <FaPlusCircle /> },
        { label: 'View Students',    path: '/collegeadmin/students/view',    icon: <FaGraduationCap /> },
        { label: 'Promote Students', path: '/collegeadmin/promote-students', icon: <FaArrowUp /> },
      ]
    },
    { label: 'Transport',        path: '/collegeadmin/transport',        icon: <FaBus /> },
    {
      label: 'Fee Management', icon: <FaReceipt />,
      subMenus: [
        { label: 'Fee Structure',             path: '/collegeadmin/fees',             icon: <FaReceipt /> },
        { label: 'Fee Collection',   path: '/collegeadmin/fee-collection',   icon: <FaMoneyBillWave /> },
        { label: 'Receipt Log',      path: '/collegeadmin/receipt-log',      icon: <FaReceipt /> },
        { label: 'Fee Due List',     path: '/collegeadmin/defaulters',       icon: <FaClipboardList /> },
        { label: 'Total Due List',   path: '/collegeadmin/total-due-list',   icon: <FaWallet /> },
        { label: 'Daily Report',     path: '/collegeadmin/daily-report',     icon: <FaFileAlt /> },
      ]
    },
    {
      label: 'Expense Management', icon: <FaBook />,
      subMenus: [
        { label: 'Expense Heads',    path: '/collegeadmin/expense-heads',    icon: <FaFileAlt /> },
        { label: 'Add Expense',      path: '/collegeadmin/add-expense',      icon: <FaPlusCircle /> },
        { label: 'Expense Book',     path: '/collegeadmin/expense-book',     icon: <FaBook /> },
      ]
    },
    {
      label: 'News', icon: <FaNewspaper />,
      subMenus: [
        { label: 'Add News',         path: '/collegeadmin/news/add',         icon: <FaNewspaper /> },
        { label: 'View News',        path: '/collegeadmin/news/view',        icon: <FaNewspaper /> },
      ]
    },
    { label: 'Notifications',    path: '/notifications',                 icon: <FaBell /> },
  ],
  clerk: [
    { label: 'Dashboard',      path: '/clerk',                  icon: <FaTachometerAlt /> },
    { label: 'Sessions',       path: '/clerk/sessions',         icon: <FaCalendarAlt /> },
    { label: 'Banks',            path: '/clerk/banks',            icon: <FaPiggyBank /> },
    {
      label: 'Students', icon: <FaGraduationCap />,
      subMenus: [
        { label: 'Add Student',    path: '/clerk/students/add',     icon: <FaPlusCircle /> },
        { label: 'View Students',  path: '/clerk/students/view',    icon: <FaGraduationCap /> },
      ]
    },
    {
      label: 'Fee Management', icon: <FaReceipt />,
      subMenus: [
        { label: 'Fee Collection', path: '/clerk/fee-collection',   icon: <FaMoneyBillWave /> },
        { label: 'Receipt Log',    path: '/clerk/receipt-log',      icon: <FaReceipt /> },
        { label: 'Fee Due List',   path: '/clerk/defaulters',       icon: <FaClipboardList /> },
        { label: 'Total Due List', path: '/clerk/total-due-list',   icon: <FaWallet /> },
        { label: 'Daily Report',   path: '/clerk/daily-report',     icon: <FaFileAlt /> },
      ]
    },
    {
      label: 'Expense Management', icon: <FaBook />,
      subMenus: [
        { label: 'Add Expense',    path: '/clerk/add-expense',      icon: <FaPlusCircle /> },
        { label: 'Expense Book',   path: '/clerk/expense-book',     icon: <FaBook /> },
      ]
    },
    {
      label: 'News', icon: <FaNewspaper />,
      subMenus: [
        { label: 'View News',      path: '/clerk/news/view',        icon: <FaNewspaper /> },
      ]
    },
    { label: 'Notifications',  path: '/notifications',          icon: <FaBell /> },
  ],
};

const Navbar = ({ isCollapsed, setIsCollapsed }) => {
  const { user, logout }   = useAuth();
  const { unread }         = useNotifications();
  const navigate           = useNavigate();
  const location           = useLocation();

  const [mobileOpen, setMobileOpen]     = useState(false);
  const [profileOpen, setProfileOpen]   = useState(false);
  const [openSubmenus, setOpenSubmenus] = useState({});

  useEffect(() => {
    setMobileOpen(false);
    setProfileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handler = (e) => {
      if (!e.target.closest('.navbar-of-erp-system-profile-wrapper')) setProfileOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleLogout = () => { 
    logout(); 
    navigate('/login'); 
  };

  const toggleSidebar = () => {
    if (window.innerWidth <= 768) {
      setMobileOpen(o => !o);
    } else {
      setIsCollapsed(o => !o);
    }
  };

  const toggleSubmenu = (label) => {
    if (isCollapsed) setIsCollapsed(false);
    setOpenSubmenus((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  const getDisplayName = () => {
    if (!user) return 'Guest';
    const cName = user.collegeName || user.college?.name || '';
    switch(user.role) {
      case 'superadmin':   return user.name || 'Super Admin';
      case 'collegeadmin': return cName || user.name || 'College Admin';
      case 'clerk':        return cName || user.name || 'Clerk';
      case 'admin':
      default:             return user.name || user.email || 'System Admin';
    }
  };

  const getRoleTitle = () => {
    switch(user?.role) {
      case 'superadmin':   return 'Super Admin';
      case 'collegeadmin': return 'College Admin';
      case 'clerk':        return 'Clerk Admin';
      case 'admin':        return 'System Admin';
      default:             return 'User';
    }
  };

  const menu = MENUS[user?.role] || [];
  const displayName = getDisplayName();
  const roleTitle = getRoleTitle();
  const avatar = displayName.charAt(0).toUpperCase();

  return (
    <>
      {/* ── MOBILE OVERLAY ── */}
      {mobileOpen && (
        <div className="navbar-of-erp-system-overlay" onClick={() => setMobileOpen(false)} />
      )}

      {/* ── LEFT SIDEBAR ── */}
      <aside className={`navbar-of-erp-system-sidebar ${isCollapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''}`}>

        {/* Brand / Logo Area */}
        <div className="navbar-of-erp-system-brand">
          <div className="navbar-of-erp-system-logo">
            <FaUniversity />
          </div>
          {!isCollapsed && <span className="navbar-of-erp-system-brand-text">ERP Portal</span>}
          <button className="navbar-of-erp-system-mobile-close" onClick={() => setMobileOpen(false)}>
            <FaTimes />
          </button>
        </div>

        {/* User Identity Badge */}
        <div className="navbar-of-erp-system-user-badge">
          <div className="navbar-of-erp-system-badge-avatar">{avatar}</div>
          {!isCollapsed && (
            <div className="navbar-of-erp-system-badge-info">
              <span className="navbar-of-erp-system-badge-name" title={displayName}>{displayName}</span>
              <span className="navbar-of-erp-system-badge-role">{roleTitle}</span>
            </div>
          )}
        </div>

        {/* Navigation Links */}
        <nav className="navbar-of-erp-system-nav">
          {!isCollapsed && <p className="navbar-of-erp-system-nav-label">Main Menu</p>}
          <ul>
            {menu.map(m => {
              // --- DROP-DOWN RENDER ---
              if (m.subMenus) {
                const isAnyChildActive = m.subMenus.some(sub => location.pathname === sub.path || location.pathname.startsWith(sub.path + '/'));
                return (
                  <li key={m.label} className="navbar-of-erp-system-nav-item">
                    <div 
                      className={`navbar-of-erp-system-nav-link navbar-of-erp-system-dropdown-parent ${isAnyChildActive ? 'navbar-of-erp-system-active-parent active' : ''} ${openSubmenus[m.label] && !isAnyChildActive ? 'navbar-of-erp-system-submenu-open' : ''}`}
                      onClick={() => toggleSubmenu(m.label)}
                      title={isCollapsed ? m.label : ''}
                    >
                      <span className="navbar-of-erp-system-nav-icon">{m.icon}</span>
                      {!isCollapsed && <span className="navbar-of-erp-system-nav-text">{m.label}</span>}
                      {!isCollapsed && (
                        <span className="navbar-of-erp-system-nav-chevron">
                          {openSubmenus[m.label] ? <FaChevronUp /> : <FaChevronDown />}
                        </span>
                      )}
                    </div>

                    {openSubmenus[m.label] && !isCollapsed && (
                      <ul className="navbar-of-erp-system-submenu">
                        {m.subMenus.map(sub => (
                          <li key={sub.path}>
                            <NavLink
                              to={sub.path}
                              end={
                                !sub.path.includes('/students') &&
                                !sub.path.endsWith('/students/view') &&
                                !sub.path.endsWith('/students/add') &&
                                !sub.path.includes('/news')
                              }
                              className={({ isActive }) => `navbar-of-erp-system-sub-link ${isActive ? 'active-child-white' : ''}`}
                            >
                              <span className="navbar-of-erp-system-sub-icon">{sub.icon}</span>
                              <span className="navbar-of-erp-system-nav-text">{sub.label}</span>
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              }

              // --- REGULAR LINK RENDER ---
              return (
                <li key={m.path} className="navbar-of-erp-system-nav-item">
                  <NavLink
                    to={m.path}
                    title={isCollapsed ? m.label : ''}
                    end={
                      !m.path.includes('/students') &&
                      !m.path.endsWith('/students/view') &&
                      !m.path.endsWith('/students/add') &&
                      !m.path.includes('/news')
                    }
                    className={({ isActive }) => `navbar-of-erp-system-nav-link ${isActive ? 'active' : ''}`}
                  >
                    <span className="navbar-of-erp-system-nav-icon">{m.icon}</span>
                    {!isCollapsed && <span className="navbar-of-erp-system-nav-text">{m.label}</span>}
                    
                    {m.path === '/notifications' && unread > 0 && !isCollapsed && (
                      <span className="navbar-of-erp-system-badge-count">{unread > 99 ? '99+' : unread}</span>
                    )}
                    {m.path === '/notifications' && unread > 0 && isCollapsed && (
                      <span className="navbar-of-erp-system-badge-dot"></span>
                    )}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Sidebar Footer */}
        <div className="navbar-of-erp-system-footer">
          {user?.role !== 'clerk' && (
            <NavLink to="/change-password" title="Security" className={({ isActive }) => `navbar-of-erp-system-footer-link ${isActive ? 'active' : ''}`}>
              <FaKey className="navbar-of-erp-system-footer-icon" />
              {!isCollapsed && <span>Change Password</span>}
            </NavLink>
          )}
          <button className="navbar-of-erp-system-logout-btn" onClick={handleLogout} title="Logout">
            <FaSignOutAlt className="navbar-of-erp-system-footer-icon" />
            {!isCollapsed && <span>Logout</span>}
          </button>
        </div>

        {/* Desktop Collapse Toggle Button */}
        <button className="navbar-of-erp-system-collapse-toggle" onClick={() => setIsCollapsed(o => !o)}>
          {isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button>
      </aside>

      {/* ── TOP HEADER ── */}
      <header className={`navbar-of-erp-system-topbar ${isCollapsed ? 'collapsed-margin' : ''}`}>

        <div className="navbar-of-erp-system-topbar-left">
          <button className="navbar-of-erp-system-menu-btn" onClick={toggleSidebar} aria-label="Toggle Menu">
            <FaBars />
          </button>
          
          <div className="navbar-of-erp-system-welcome">
            <span className="navbar-of-erp-system-welcome-greeting">Welcome,</span>
            <span className="navbar-of-erp-system-welcome-name">{displayName}</span>
          </div>
        </div>

        <div className="navbar-of-erp-system-topbar-right">
          
          {/* Notification Icon */}
          <button className="navbar-of-erp-system-top-icon" onClick={() => navigate('/notifications')} title="Notifications">
            <FaBell />
            {unread > 0 && <span className="navbar-of-erp-system-top-notif-dot">{unread > 99 ? '99+' : unread}</span>}
          </button>

          {/* Profile Dropdown */}
          <div className="navbar-of-erp-system-profile-wrapper">
            <button className="navbar-of-erp-system-profile-trigger" onClick={() => setProfileOpen(!profileOpen)}>
              <div className="navbar-of-erp-system-top-avatar">{avatar}</div>
            </button>

            {profileOpen && (
              <div className="navbar-of-erp-system-profile-menu">
                <div className="navbar-of-erp-system-profile-menu-header">
                  <div className="navbar-of-erp-system-pm-avatar">{avatar}</div>
                  <div className="navbar-of-erp-system-pm-details">
                    <strong title={displayName}>{displayName}</strong>
                    <span>{roleTitle}</span>
                  </div>
                </div>
                <div className="navbar-of-erp-system-profile-menu-divider" />
                {user?.role !== 'clerk' && (
                  <>
                    <button onClick={() => { navigate('/change-password'); setProfileOpen(false); }}>
                      <FaKey /> Account Security
                    </button>
                    <div className="navbar-of-erp-system-profile-menu-divider" />
                  </>
                )}
                <button onClick={handleLogout} className="navbar-of-erp-system-logout-action">
                  <FaSignOutAlt /> Sign Out
                </button>
              </div>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default Navbar;